import { trackingMiddleware } from '@vfde-sails/tracking';
import { configureStore } from '@reduxjs/toolkit';
import gladosApi from './container/App/api/glados';
import stoneDopSlice from './container/App/slice';
import stoneDopListener from './container/App/listener';

export const store = configureStore({
    reducer: {
        [stoneDopSlice.reducerPath]: stoneDopSlice.reducer,
        [gladosApi.reducerPath]: gladosApi.reducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware()
        .prepend(stoneDopListener.middleware) // Listener goes first because of special actions in it
        .concat(gladosApi.middleware, trackingMiddleware),
});

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * Infer AppDispatch
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Export dispatch function
 */
export const useDispatch = () => store.dispatch;
